
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"type.<CHART>":"Diagramm","type.<MAP>":"Karte","type.<TABLE>":"Tabelle"},"en":{"type.<CHART>":"Chart","type.<MAP>":"Map","type.<TABLE>":"Table"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();